import { useTheme } from 'styled-components';
import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const ConvertIconGe: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
  color,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.text.secondary;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.82764 0.4241C9.25976 0.386975 8.76768 0.818961 8.73193 1.38821C8.69481 1.95609 9.12817 2.4441 9.69604 2.48123C13.1047 2.69848 15.8057 5.53543 15.8057 8.99905C15.8057 10.5087 15.2919 11.8971 14.4307 13.0032V11.2979C14.4307 10.7286 13.9687 10.2666 13.3994 10.2666C12.8302 10.2666 12.3682 10.7286 12.3682 11.2979V15.1866C12.3682 15.7558 12.8302 16.2178 13.3994 16.2178H17.2881C17.8573 16.2178 18.3193 15.7558 18.3193 15.1866C18.3193 14.6173 17.8573 14.1553 17.2881 14.1553H16.144C17.2249 12.718 17.8682 10.9335 17.8682 8.99905C17.8682 4.4423 14.3129 0.7101 9.82764 0.4241ZM1.71191 1.0928C1.14266 1.0928 0.680664 1.5548 0.680664 2.12405C0.680664 2.6933 1.14266 3.1553 1.71191 3.1553H2.99023C1.56242 4.68953 0.680664 6.73932 0.680664 8.99905C0.680664 13.7414 4.53066 17.5928 9.27441 17.5928C9.84366 17.5928 10.3057 17.1308 10.3057 16.5616C10.3057 15.9923 9.84366 15.5303 9.27441 15.5303C5.66916 15.5303 2.74316 12.6043 2.74316 8.99905C2.74316 7.24516 3.44298 5.65857 4.56934 4.48465V6.01272C4.56934 6.58197 5.03134 7.04397 5.60059 7.04397C6.16984 7.04397 6.63184 6.58197 6.63184 6.01272V2.12405C6.63184 1.5548 6.16984 1.0928 5.60059 1.0928H1.71191Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};

export default ConvertIconGe;
